import React from 'react';
import { Box} from '@mui/material';
import PropTypes from 'prop-types';
import './styles.css';

const VerificationCode = ({ onSuccess, passcode }) => {

  return (
    <Box className="verification-box">
    <div className= "container">
      <p className="verification-description" id="popup-description">
        Verification Code
      </p>
      <div className="verification-text">Copy the below code and paste it into the commissioning app.</div>
      <div className="verification-code">{passcode}</div>
    </div>
    </Box>
  );
};

VerificationCode.propTypes = {
  onSuccess: PropTypes.func.isRequired,
};

export default VerificationCode;

